<template>
  <div style="height: 100%">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>

export default {
  name:'main1',
  mounted(){

  },

}
</script>
<style lang="less">
@import "./styles/common.less";
</style>


// WEBPACK FOOTER //
// app.vue